import cx from 'classnames'
import * as React from 'react'

import Icon from '../icon'
import { SpacingProps } from '../shared-types'
import Spacer from '../spacer'
import VisuallyHidden from '../visually-hidden'
import styles from './tag.module.scss'

export type Props = SpacingProps & {
  children: string | React.ReactNode
  onRemove?: (arg0: React.MouseEvent<EventTarget>) => void
  onClick?: (arg0: React.MouseEvent<EventTarget>) => void
  theme?: 'neutral' | 'warning' | undefined
  active?: boolean
  className?: string
  tagSize?: 'small' | 'regular' | undefined
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  is?: React.ElementType<any>
}

export default function Tag({
  children,
  onRemove,
  onClick,
  theme = 'neutral',
  active,
  className,
  tagSize = 'regular',
  is,
  ...otherProps
}: Props) {
  const ButtonOrSpan = onClick ? 'button' : 'span'
  const _is = is || 'span'
  return (
    <Spacer
      {...otherProps}
      is={_is}
      className={cx(
        styles.tag,
        styles[`theme-${theme}`],
        {
          [styles.active]: active,
          [styles.interactive]: onClick,
        },
        tagSize === 'small' && styles.small,
        className,
      )}
    >
      <ButtonOrSpan className={styles.content} onClick={onClick}>
        {children}
      </ButtonOrSpan>
      {onRemove && (
        <button className={styles.removeButton} onClick={onRemove}>
          <VisuallyHidden is="span">Remove tag</VisuallyHidden>
          <Icon icon="close" size={14} />
        </button>
      )}
    </Spacer>
  )
}
